// Regex constants
const REGEX_PASSWORD_SERVICE_ADMIN = /^[a-zA-Z0-9@#$%!]{0,12}$/;
const REGEX_PASSWORD_DIGIT = /^\d*$/;

export default function usePasswordRule(isServiceAdmin) {
  return isServiceAdmin
    ? {
        regexPassword: REGEX_PASSWORD_SERVICE_ADMIN,
        maxLength: 12,
        minLength: 6,
      }
    : {
        regexPassword: REGEX_PASSWORD_DIGIT,
        maxLength: 6,
        minLength: 6,
      };
}
